import {
  EEnhancementImageType,
  IEnhancementImageVariant,
  TEnhanceProductImageListType,
  TEnhanceProductImageRequestType,
  TEnhanceProductImageResult
} from 'models/product'

export const getEnhanceImageRequestType = (
  type: EEnhancementImageType
): TEnhanceProductImageRequestType => {
  if (type === EEnhancementImageType.BACKGROUND) {
    return 'removeBackground'
  }

  return type
}

export const getEnhanceImageListType = (
  type: EEnhancementImageType
): TEnhanceProductImageListType => {
  if (type === EEnhancementImageType.BACKGROUND) {
    return 'background'
  }

  return type
}

export const normalizeEnhancementImage = (
  result: TEnhanceProductImageResult | null | undefined
): IEnhancementImageVariant | null => {
  if (!result) {
    return null
  }

  if (typeof result === 'string') {
    return { image: result }
  }

  if ('image' in result && result.image) {
    return result
  }

  if ('imageUrl' in result && result.imageUrl) {
    return { image: result.imageUrl }
  }

  return null
}
